import { Card, Stack, Typography } from '@mui/material';
import { SVLink } from '../core';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { useTransactionFormModal } from '@/hooks/stores/useTransactionFormModal';
import { useOwnerSelectFormModal } from '@/hooks/stores/useOwnerSelectFormModal';
import { TransactionType } from '@/types/transactionRequests';
import { useState } from 'react';
import { BankAccountDetails, BankAccountStatus } from '@/types/bankAccounts';
import BankAccountLockModal from './modals/BankAccountLockModal';
import BankAccountCloseModal from './modals/BankAccoutCloseModal';
import BankAccountUnlockModal from './modals/BankAccountUnlockModal';

type BankAccountDetailsActionsProps = {
  accountDetails: BankAccountDetails;
  customerId: string;
};

export default function BankAccountDetailsActions({
  customerId,
  accountDetails,
}: BankAccountDetailsActionsProps) {
  const { status, uuid: bankAccountId, accountNumberLast4 } = accountDetails;

  const [openAccountLockModal, setOpenAccountLockModal] = useState(false);
  const [openAccountUnlockModal, setOpenAccountUnlockModal] = useState(false);
  const [openAccountCloseModal, setOpenAccountCloseModal] = useState(false);

  const { isStaff } = useAuthUser();
  const { openTransactionFormModal } = useTransactionFormModal();
  const { openOwnerSelectFormModal } = useOwnerSelectFormModal();

  const isClosed = status === BankAccountStatus.Closed;
  const isLocked = status === BankAccountStatus.Locked;

  if (isClosed) {
    return null;
  }

  function handleMenuItemClick(type: TransactionType) {
    if (customerId) {
      openTransactionFormModal({ bankAccountId, customerId, type });
    } else {
      openOwnerSelectFormModal({ type, bankAccountId });
    }
  }

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        Actions
      </Typography>
      <Stack spacing={2}>
        {!isLocked && (
          <>
            <SVLink to="" onClick={() => handleMenuItemClick('deposit')}>
              Request a Deposit
            </SVLink>
            <SVLink to="" onClick={() => handleMenuItemClick('transfer')}>
              Request a Transfer
            </SVLink>
            <SVLink to="" onClick={() => handleMenuItemClick('wire')}>
              Request a Wire
            </SVLink>
          </>
        )}
        {isStaff && (
          <>
            <SVLink
              onClick={() => {
                if (isLocked) {
                  setOpenAccountUnlockModal(true);
                } else {
                  setOpenAccountLockModal(true);
                }
              }}
              isWarningLink={!isLocked}
              to="">
              {isLocked ? 'Unlock' : 'Lock'} Account
            </SVLink>
            <SVLink
              onClick={() => setOpenAccountCloseModal(true)}
              isWarningLink
              to="">
              Close Account
            </SVLink>
            <BankAccountLockModal
              bankAccountId={bankAccountId}
              open={openAccountLockModal}
              setOpen={setOpenAccountLockModal}
            />
            <BankAccountUnlockModal
              bankAccountId={bankAccountId}
              accountNumberLast4={accountNumberLast4}
              open={openAccountUnlockModal}
              setOpen={setOpenAccountUnlockModal}
            />
            <BankAccountCloseModal
              bankAccountId={bankAccountId}
              open={openAccountCloseModal}
              setOpen={setOpenAccountCloseModal}
            />
          </>
        )}
      </Stack>
    </Card>
  );
}
